import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { allRoutes } from "../AllRoutes";

const AuthLayout = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const userData = localStorage.getItem("user");

      if (!userData) {
        setAuthorized(false);
        setLoading(false);
        return;
      }

      const user = JSON.parse(userData);
      const route = allRoutes.find((r) => r.path === location.pathname);

      if (!route) {
        setAuthorized("not-found");
      } else {
        const hasRoleAccess = route.roles.includes(user.role);
        const hasPermission =
          route.permissions.length === 0 ||
          route.permissions.every((perm) => user.permissions?.includes(perm));

        setAuthorized(hasRoleAccess && hasPermission);
      }

      setLoading(false);
    };

    checkAuth();
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="w-full h-screen flex flex-col items-center justify-center bg-white text-gray-700">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-600 border-opacity-50 mb-4" />
        <p className="text-lg font-medium">Loading...</p>
      </div>
    );
  }

  if (authorized === "not-found") {
    return <Navigate to="/404" replace />;
  }

  if (!authorized) {
    if (location?.pathname === '/dashboard') {
      return <Navigate to="/login" replace />;
    } else {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};

export default AuthLayout;
